import { IconFileDescription } from '@tabler/icons-react';
import { FormattedMessage } from 'react-intl';

const icons = {
    IconFileDescription,
};

// ==============================|| MENU ITEMS - DASHBOARD ||============================== //

const farmManagement = {
    id: 'Farm Management',
    title: <FormattedMessage id="Farm Management" />,
    icon: icons.IconFileDescription,
    type: 'group',
    children: [
        {
            id: 'Farm Records',
            title: <FormattedMessage id="Farm Records" />,
            type: 'item',
            url: '/farm-records/list',
            icon: icons.IconFileDescription,
            breadcrumbs: false
        },
    ]
};

export default farmManagement;